module.exports = __webpack_public_path__ + "static/img/slogan.fcc683ac.png";